//#region src/permissions.ts
/**
* Given to users to access integrations panel.
*/
const CAN_MANAGE_INTEGRATIONS = "can_manage_integrations";
/**
* Given to users to access AI Mystic app.
*/
const CAN_ACCESS_MYSTIC = "can_access_mystic";
/**
* Given to users that can list and search workspaces.
*/
const CAN_LIST_WORKSPACES = "can_list_workspaces";
/**
* Given to users that can create workspaces.
*/
const CAN_CREATE_WORKSPACES = "can_create_workspaces";
/**
* Given to users that can read workspaces.
*/
const CAN_READ_WORKSPACES = "can_read_workspaces";
/**
* Given to users that can update workspaces.
*/
const CAN_UPDATE_WORKSPACES = "can_update_workspaces";
/**
* Given to users that can delete workspaces.
*/
const CAN_DELETE_WORKSPACES = "can_delete_workspaces";
/**
* Given to users that can publish their own workspaces.
*/
const CAN_PUBLISH_WORKSPACES = "can_publish_workspaces";
/**
* Given to users that can list own agents.
*/
const CAN_LIST_AGENTS = "can_list_agents";
/**
* Given to users that can create own agents.
*/
const CAN_CREATE_AGENTS = "can_create_agents";
/**
* Given to users that can read own agents.
*/
const CAN_READ_AGENTS = "can_read_agents";
/**
* Given to users that can update own agents.
*/
const CAN_UPDATE_AGENTS = "can_update_agents";
/**
* Given to users that can delete own agents.
*/
const CAN_DELETE_AGENTS = "can_delete_agents";
/**
* Given to users that can prompt the execution of agent tools.
*/
const CAN_EXECUTE_AGENT_TOOLS = "can_execute_agent_tools";
/**
* [chatroom only] Given to user when they can kick other users from a chat room
*/
const CAN_KICK_USERS = "can_kick_users";
/**
* [chatroom only] Given to user when they can ban other users from a chat room
*/
const CAN_BAN_USERS = "can_ban_users";
/**
* [chatroom only] Given to user when they can edit a chat room
*/
const CAN_EDIT_CHAT_ROOM = "can_edit_chat_rooms";
/**
* [chatroom only] Given to users who can invite AI agents to a chat room
*/
const CAN_INVITE_AI_AGENTS_TO_ROOM = "can_invite_ai_agents_to_room";
/**
* [chatroom only] Given to users who can invite other users to a chat room
*/
const CAN_INVITE_USERS_TO_ROOM = "can_invite_users_to_room";
/**
* [chatroom only] Given to users who can manage AI agents in a chat room
*/
const CAN_MANAGE_AIS_IN_ROOM = "can_manage_ais_in_room";
/**
* [chatroom only] Given to users who can manage chat room roles
*/
const CAN_MANAGE_CHAT_ROOM_ROLES = "can_manage_chat_room_roles";
/**
* [chatroom only] Given to users who can delete a chat room
*/
const CAN_DELETE_ROOM = "can_delete_room";
/**
* [chatroom only] Given to users who can delete messages in a chat room
*/
const CAN_DELETE_MESSAGES = "can_delete_messages";
/**
* [wiki only] Given to users who can list wiki pages
*/
const CAN_LIST_WIKI_PAGES = "can_list_wiki_pages";
/**
* [wiki only] Given to users who can create wiki pages
*/
const CAN_CREATE_WIKI_PAGES = "can_create_wiki_pages";
/**
* [wiki only] Given to users who can read wiki pages
*/
const CAN_READ_WIKI_PAGES = "can_read_wiki_pages";
/**
* [wiki only] Given to users who can update wiki pages
*/
const CAN_UPDATE_WIKI_PAGES = "can_update_wiki_pages";
/**
* [wiki only] Given to users who can delete wiki pages
*/
const CAN_DELETE_WIKI_PAGES = "can_delete_wiki_pages";
/**
* [wiki only] Given to users who can manage wiki pages
*/
const CAN_MANAGE_WIKI_PAGES = "can_manage_wiki_pages";
/**
* [org only] Given to users who can manage organization billing
*/
const CAN_MANAGE_ORGANIZATION_BILLING = "can_manage_organization_billing";
/**
* [org only] Given to users who can manage organization users
*/
const CAN_MANAGE_ORGANIZATION_USERS = "can_manage_organization_users";
/**
* [org only] Given to users who controls the account
*/
const IS_ORGANIZATION_ACCOUNT_OWNER = "is_organization_account_owner";
/**
* [app only] Given to users who can create chat rooms
*/
const CAN_CREATE_CHAT_ROOMS = "can_create_chat_rooms";
/**
* Can create workspace deployments
*/
const CAN_CREATE_WORKSPACE_DEPLOYMENTS = "can_create_workspace_deployments";
/**
* Can read workspace deployments
*/
const CAN_READ_WORKSPACE_DEPLOYMENTS = "can_read_workspace_deployments";
/**
* Can update workspace deployments
*/
const CAN_UPDATE_WORKSPACE_DEPLOYMENTS = "can_update_workspace_deployments";
/**
* Can delete workspace deployments
*/
const CAN_DELETE_WORKSPACE_DEPLOYMENTS = "can_delete_workspace_deployments";
/**
* Can manage workspace deployments
*/
const CAN_MANAGE_WORKSPACE_DEPLOYMENTS = "can_manage_workspace_deployments";
/**
* Can manage LLM profiles
*/
const CAN_READ_LLM_PROFILE = "can_read_llm_profile";
/**
* Can create LLM profiles
*/
const CAN_WRITE_LLM_PROFILE = "can_write_llm_profile";
/**
* Can update LLM profiles
*/
const CAN_UPDATE_LLM_PROFILE = "can_update_llm_profile";
/**
* Can delete LLM profiles
*/
const CAN_DELETE_LLM_PROFILE = "can_delete_llm_profile";
/**
* Can manage LLM profile tools
*/
const CAN_QUERY_LLM_PROFILE = "can_query_llm_profile";
/**
* Can list and search users
*/
const APP_CAN_LIST_USERS = "app_can_list_users";
/**
* Can read user information
*/
const APP_CAN_READ_USER = "app_can_read_user";
/**
* Can create new users
*/
const APP_CAN_CREATE_USER = "app_can_create_user";
/**
* Can update user information
*/
const APP_CAN_UPDATE_USER = "app_can_update_user";
/**
* Can delete users
*/
const APP_CAN_DELETE_USER = "app_can_delete_user";
/**
* Can manage permissions
*/
const APP_CAN_MANAGE_PERMISSIONS = "app_can_manage_permissions";
/**
* Can manage system roles
*/
const APP_CAN_MANAGE_ROLES = "app_can_manage_roles";
/**
* Can list and search roles
*/
const APP_CAN_LIST_ROLES = "app_can_list_roles";
/**
* Can read role information
*/
const APP_CAN_READ_ROLE = "app_can_read_role";
/**
* Can create new roles
*/
const APP_CAN_CREATE_ROLE = "app_can_create_role";
/**
* Can update role information
*/
const APP_CAN_UPDATE_ROLE = "app_can_update_role";
/**
* Can delete roles
*/
const APP_CAN_DELETE_ROLE = "app_can_delete_role";
/**
* Can assign roles to users
*/
const APP_CAN_ASSIGN_ROLES = "app_can_assign_roles";
/**
* Can assign roles to organizations
*/
const APP_CAN_ASSIGN_ORGANIZATION_ROLES = "app_can_assign_organization_roles";
/**
* Can assign roles to chatrooms
*/
const APP_CAN_ASSIGN_CHATROOM_ROLES = "app_can_assign_chatroom_roles";
/**
* Can list and search plans
*/
const APP_CAN_LIST_PLANS = "app_can_list_plans";
/**
* Can read plan information
*/
const APP_CAN_READ_PLAN = "app_can_read_plan";
/**
* Can create new plans
*/
const APP_CAN_CREATE_PLAN = "app_can_create_plan";
/**
* Can update plan information
*/
const APP_CAN_UPDATE_PLAN = "app_can_update_plan";
/**
* Can delete plans
*/
const APP_CAN_DELETE_PLAN = "app_can_delete_plan";
/**
* Can assign plans to users
*/
const APP_CAN_ASSIGN_PLANS = "app_can_assign_plans";
/**
* Can manage plan website visibility
*/
const APP_CAN_MANAGE_PLAN_WEBSITE_VISIBILITY = "app_can_manage_plan_website_visibility";
/**
* Can list and search organizations
*/
const APP_CAN_LIST_ORGANIZATIONS = "app_can_list_organizations";
/**
* Can read organization information
*/
const APP_CAN_READ_ORGANIZATION = "app_can_read_organization";
/**
* Can create new organizations
*/
const APP_CAN_CREATE_ORGANIZATION = "app_can_create_organization";
/**
* Can update organization information
*/
const APP_CAN_UPDATE_ORGANIZATION = "app_can_update_organization";
/**
* Can delete organizations
*/
const APP_CAN_DELETE_ORGANIZATION = "app_can_delete_organization";
/**
* Can access the admin backend
*/
const APP_CAN_ACCESS_BACKEND = "app_can_access_backend";
/**
* Can access the AI Mystic mini app
*/
const APP_CAN_ACCESS_MINI_APP = "app_can_access_mini_app";
/**
* Can access the application logs
*/
const APP_CAN_VIEW_LOGS = "app_can_view_logs";
/**
* Can access the application dashboard
*/
const APP_CAN_VIEW_DASHBOARD = "app_can_view_dashboard";
/**
* Can edit all agents in the system
*/
const APP_CAN_EDIT_ALL_AGENTS = "app_can_edit_all_agents";
/**
* Can delete all agents in the system
*/
const APP_CAN_DELETE_ALL_AGENTS = "app_can_delete_all_agents";
/**
* Can list all agents in the system
*/
const APP_CAN_LIST_ALL_AGENTS = "app_can_list_all_agents";
/**
* Can edit all workspaces in the system
*/
const APP_CAN_EDIT_ALL_WORKSPACES = "app_can_edit_all_workspaces";
/**
* Can create webpages
*/
const APP_CAN_CREATE_WEBPAGE = "app_can_create_webpage";
/**
* Can read webpages
*/
const APP_CAN_READ_WEBPAGE = "app_can_read_webpage";
/**
* Can update webpages
*/
const APP_CAN_UPDATE_WEBPAGE = "app_can_update_webpage";
/**
* Can delete webpages
*/
const APP_CAN_DELETE_WEBPAGE = "app_can_delete_webpage";
/**
* Can manage webpages
*/
const APP_CAN_MANAGE_WEBPAGE = "app_can_manage_webpage";
/**
* Can manage model profiles
*/
const APP_CAN_VIEW_MODEL_PROFILES = "app_can_view_model_profiles";
/**
* Can create model profiles
*/
const APP_CAN_CREATE_MODEL_PROFILES = "app_can_create_model_profiles";
/**
* Can read model profiles
*/
const APP_CAN_READ_MODEL_PROFILES = "app_can_read_model_profiles";
/**
* Can update model profiles
*/
const APP_CAN_UPDATE_MODEL_PROFILES = "app_can_update_model_profiles";
/**
* Can delete model profiles
*/
const APP_CAN_DELETE_MODEL_PROFILES = "app_can_delete_model_profiles";
const APP_CAN_EXECUTE_LLM_PROFILE_TOOLS = "app_can_execute_llm_profile_tools";
/**
* Can list and search transactions
*/
const APP_CAN_LIST_TRANSACTIONS = "app_can_list_transactions";
/**
* Can create a transaction record
*/
const APP_CAN_CREATE_TRANSACTION = "app_can_create_transaction";
/**
* Can read transaction record
*/
const APP_CAN_READ_TRANSACTION = "app_can_read_transaction";
/**
* Can update transaction record
*/
const APP_CAN_UPDATE_TRANSACTION = "app_can_update_transaction";
/**
* Can delete transaction record
*/
const APP_CAN_DELETE_TRANSACTION = "app_can_delete_transaction";
/**
* Can ignore platform limits
*/
const APP_IGNORE_LIMITS = "app_ignore_limits";
const ALL_APP_PERMISSIONS = [
	APP_CAN_LIST_USERS,
	APP_CAN_READ_USER,
	APP_CAN_CREATE_USER,
	APP_CAN_UPDATE_USER,
	APP_CAN_DELETE_USER,
	APP_CAN_MANAGE_PERMISSIONS,
	APP_CAN_MANAGE_ROLES,
	APP_CAN_LIST_ROLES,
	APP_CAN_READ_ROLE,
	APP_CAN_CREATE_ROLE,
	APP_CAN_UPDATE_ROLE,
	APP_CAN_DELETE_ROLE,
	APP_CAN_ASSIGN_ROLES,
	APP_CAN_ASSIGN_ORGANIZATION_ROLES,
	APP_CAN_ASSIGN_CHATROOM_ROLES,
	APP_CAN_LIST_PLANS,
	APP_CAN_READ_PLAN,
	APP_CAN_CREATE_PLAN,
	APP_CAN_UPDATE_PLAN,
	APP_CAN_DELETE_PLAN,
	APP_CAN_ASSIGN_PLANS,
	APP_CAN_MANAGE_PLAN_WEBSITE_VISIBILITY,
	APP_CAN_LIST_ORGANIZATIONS,
	APP_CAN_READ_ORGANIZATION,
	APP_CAN_CREATE_ORGANIZATION,
	APP_CAN_UPDATE_ORGANIZATION,
	APP_CAN_DELETE_ORGANIZATION,
	APP_CAN_ACCESS_BACKEND,
	APP_CAN_VIEW_LOGS,
	APP_CAN_VIEW_DASHBOARD,
	APP_CAN_LIST_ALL_AGENTS,
	APP_CAN_EDIT_ALL_AGENTS,
	APP_CAN_DELETE_ALL_AGENTS,
	APP_CAN_EDIT_ALL_WORKSPACES,
	APP_CAN_CREATE_WEBPAGE,
	APP_CAN_READ_WEBPAGE,
	APP_CAN_UPDATE_WEBPAGE,
	APP_CAN_DELETE_WEBPAGE,
	APP_CAN_MANAGE_WEBPAGE,
	APP_CAN_VIEW_MODEL_PROFILES,
	APP_CAN_CREATE_MODEL_PROFILES,
	APP_CAN_READ_MODEL_PROFILES,
	APP_CAN_UPDATE_MODEL_PROFILES,
	APP_CAN_DELETE_MODEL_PROFILES,
	APP_CAN_EXECUTE_LLM_PROFILE_TOOLS,
	APP_CAN_LIST_TRANSACTIONS,
	APP_CAN_CREATE_TRANSACTION,
	APP_CAN_READ_TRANSACTION,
	APP_CAN_UPDATE_TRANSACTION,
	APP_CAN_DELETE_TRANSACTION,
	APP_IGNORE_LIMITS,
	CAN_MANAGE_INTEGRATIONS,
	CAN_LIST_WORKSPACES,
	CAN_CREATE_WORKSPACES,
	CAN_READ_WORKSPACES,
	CAN_UPDATE_WORKSPACES,
	CAN_DELETE_WORKSPACES,
	CAN_PUBLISH_WORKSPACES,
	CAN_EXECUTE_AGENT_TOOLS,
	CAN_LIST_AGENTS,
	CAN_CREATE_AGENTS,
	CAN_UPDATE_AGENTS,
	CAN_READ_AGENTS,
	CAN_DELETE_AGENTS,
	CAN_CREATE_WORKSPACE_DEPLOYMENTS,
	CAN_READ_WORKSPACE_DEPLOYMENTS,
	CAN_UPDATE_WORKSPACE_DEPLOYMENTS,
	CAN_DELETE_WORKSPACE_DEPLOYMENTS,
	CAN_MANAGE_WORKSPACE_DEPLOYMENTS,
	CAN_READ_LLM_PROFILE,
	CAN_WRITE_LLM_PROFILE,
	CAN_UPDATE_LLM_PROFILE,
	CAN_DELETE_LLM_PROFILE,
	CAN_QUERY_LLM_PROFILE
];
const PERMISSION_DEFINITIONS = {
	[CAN_MANAGE_INTEGRATIONS]: {
		description: "Can manage integrations. Enables the integrations panel for a user.",
		type: "global"
	},
	[CAN_ACCESS_MYSTIC]: {
		description: "Can access the AI Mystic app. Allows access to the application.",
		type: "global"
	},
	[CAN_LIST_AGENTS]: {
		description: "Can list and search their own agents. Enables the agent listing panel for a user.",
		type: "global"
	},
	[CAN_CREATE_AGENTS]: {
		description: "Can create their own agents",
		type: "global"
	},
	[CAN_READ_AGENTS]: {
		description: "Can read their own agents",
		type: "global"
	},
	[CAN_UPDATE_AGENTS]: {
		description: "Can update their own agents",
		type: "global"
	},
	[CAN_DELETE_AGENTS]: {
		description: "Can delete their own agents",
		type: "global"
	},
	[CAN_EXECUTE_AGENT_TOOLS]: {
		description: "Can prompt the execution of agent tools",
		type: "global"
	},
	[CAN_LIST_WORKSPACES]: {
		description: "Can list and search their own workspaces. Enables the workspace listing panel for a user.",
		type: "global"
	},
	[CAN_CREATE_WORKSPACES]: {
		description: "Can create their own workspaces",
		type: "global"
	},
	[CAN_READ_WORKSPACES]: {
		description: "Can read their own workspaces",
		type: "global"
	},
	[CAN_UPDATE_WORKSPACES]: {
		description: "Can update their own workspaces",
		type: "global"
	},
	[CAN_DELETE_WORKSPACES]: {
		description: "Can delete their own workspaces",
		type: "global"
	},
	[CAN_PUBLISH_WORKSPACES]: {
		description: "Can publish their own workspaces",
		type: "global"
	},
	[CAN_KICK_USERS]: {
		description: "Can kick other users from a chat room",
		type: "room"
	},
	[CAN_BAN_USERS]: {
		description: "Can ban other users from a chat room",
		type: "room"
	},
	[CAN_EDIT_CHAT_ROOM]: {
		description: "Can edit a chat room",
		type: "room"
	},
	[CAN_INVITE_AI_AGENTS_TO_ROOM]: {
		description: "Can invite AI agents to a chat room",
		type: "room"
	},
	[CAN_INVITE_USERS_TO_ROOM]: {
		description: "Can invite other users to a chat room",
		type: "room"
	},
	[CAN_MANAGE_AIS_IN_ROOM]: {
		description: "Can manage AI agents in a chat room",
		type: "room"
	},
	[CAN_MANAGE_CHAT_ROOM_ROLES]: {
		description: "Can manage chat room roles",
		type: "room"
	},
	[CAN_DELETE_ROOM]: {
		description: "Can delete a chat room",
		type: "room"
	},
	[CAN_DELETE_MESSAGES]: {
		description: "Can delete messages in a chat room",
		type: "room"
	},
	[CAN_LIST_WIKI_PAGES]: {
		description: "Can list wiki pages",
		type: "global"
	},
	[CAN_CREATE_WIKI_PAGES]: {
		description: "Can create wiki pages",
		type: "global"
	},
	[CAN_READ_WIKI_PAGES]: {
		description: "Can read wiki pages",
		type: "global"
	},
	[CAN_UPDATE_WIKI_PAGES]: {
		description: "Can update wiki pages",
		type: "global"
	},
	[CAN_DELETE_WIKI_PAGES]: {
		description: "Can delete wiki pages",
		type: "global"
	},
	[CAN_MANAGE_WIKI_PAGES]: {
		description: "Can manage wiki pages",
		type: "global"
	},
	[CAN_MANAGE_ORGANIZATION_BILLING]: {
		description: "Can manage organization billing",
		type: "org"
	},
	[CAN_MANAGE_ORGANIZATION_USERS]: {
		description: "Can manage organization users",
		type: "org"
	},
	[IS_ORGANIZATION_ACCOUNT_OWNER]: {
		description: "Controls the account",
		type: "org"
	},
	[CAN_CREATE_CHAT_ROOMS]: {
		description: "Can create chat rooms",
		type: "global"
	},
	[CAN_CREATE_WORKSPACE_DEPLOYMENTS]: {
		description: "Can create workspace deployments",
		type: "global"
	},
	[CAN_READ_WORKSPACE_DEPLOYMENTS]: {
		description: "Can read workspace deployments",
		type: "global"
	},
	[CAN_UPDATE_WORKSPACE_DEPLOYMENTS]: {
		description: "Can update workspace deployments",
		type: "global"
	},
	[CAN_DELETE_WORKSPACE_DEPLOYMENTS]: {
		description: "Can delete workspace deployments",
		type: "global"
	},
	[CAN_MANAGE_WORKSPACE_DEPLOYMENTS]: {
		description: "Can manage workspace deployments",
		type: "global"
	},
	[CAN_READ_LLM_PROFILE]: {
		description: "Can read LLM profiles",
		type: "global"
	},
	[CAN_WRITE_LLM_PROFILE]: {
		description: "Can create LLM profiles",
		type: "global"
	},
	[CAN_UPDATE_LLM_PROFILE]: {
		description: "Can update LLM profiles",
		type: "global"
	},
	[CAN_DELETE_LLM_PROFILE]: {
		description: "Can delete LLM profiles",
		type: "global"
	},
	[CAN_QUERY_LLM_PROFILE]: {
		description: "Can execute LLM profile tools",
		type: "global"
	},
	[APP_CAN_LIST_USERS]: {
		description: "Can list and search users",
		type: "internal"
	},
	[APP_CAN_READ_USER]: {
		description: "Can read user information",
		type: "internal"
	},
	[APP_CAN_CREATE_USER]: {
		description: "Can create new users",
		type: "internal"
	},
	[APP_CAN_UPDATE_USER]: {
		description: "Can update user information",
		type: "internal"
	},
	[APP_CAN_DELETE_USER]: {
		description: "Can delete users",
		type: "internal"
	},
	[APP_CAN_MANAGE_PERMISSIONS]: {
		description: "Can manage permissions",
		type: "internal"
	},
	[APP_CAN_MANAGE_ROLES]: {
		description: "Can manage system roles",
		type: "internal"
	},
	[APP_CAN_LIST_ROLES]: {
		description: "Can list and search roles",
		type: "internal"
	},
	[APP_CAN_READ_ROLE]: {
		description: "Can read role information",
		type: "internal"
	},
	[APP_CAN_CREATE_ROLE]: {
		description: "Can create new roles",
		type: "internal"
	},
	[APP_CAN_UPDATE_ROLE]: {
		description: "Can update role information",
		type: "internal"
	},
	[APP_CAN_DELETE_ROLE]: {
		description: "Can delete roles",
		type: "internal"
	},
	[APP_CAN_ASSIGN_ROLES]: {
		description: "Can assign roles to users",
		type: "internal"
	},
	[APP_CAN_ASSIGN_ORGANIZATION_ROLES]: {
		description: "Can assign roles to organizations",
		type: "internal"
	},
	[APP_CAN_ASSIGN_CHATROOM_ROLES]: {
		description: "Can assign roles to chatrooms",
		type: "internal"
	},
	[APP_CAN_LIST_PLANS]: {
		description: "Can list and search plans",
		type: "internal"
	},
	[APP_CAN_READ_PLAN]: {
		description: "Can read plan information",
		type: "internal"
	},
	[APP_CAN_CREATE_PLAN]: {
		description: "Can create new plans",
		type: "internal"
	},
	[APP_CAN_UPDATE_PLAN]: {
		description: "Can update plan information",
		type: "internal"
	},
	[APP_CAN_DELETE_PLAN]: {
		description: "Can delete plans",
		type: "internal"
	},
	[APP_CAN_ASSIGN_PLANS]: {
		description: "Can assign plans to users",
		type: "internal"
	},
	[APP_CAN_MANAGE_PLAN_WEBSITE_VISIBILITY]: {
		description: "Can manage plan website visibility",
		type: "internal"
	},
	[APP_CAN_LIST_ORGANIZATIONS]: {
		description: "Can list and search organizations",
		type: "internal"
	},
	[APP_CAN_READ_ORGANIZATION]: {
		description: "Can read organization information",
		type: "internal"
	},
	[APP_CAN_CREATE_ORGANIZATION]: {
		description: "Can create new organizations",
		type: "internal"
	},
	[APP_CAN_UPDATE_ORGANIZATION]: {
		description: "Can update organization information",
		type: "internal"
	},
	[APP_CAN_DELETE_ORGANIZATION]: {
		description: "Can delete organizations",
		type: "internal"
	},
	[APP_CAN_ACCESS_BACKEND]: {
		description: "Can access the admin backend",
		type: "internal"
	},
	[APP_CAN_ACCESS_MINI_APP]: {
		description: "Can access the AI Mystic mini app",
		type: "internal"
	},
	[APP_CAN_VIEW_LOGS]: {
		description: "Can access the application logs",
		type: "internal"
	},
	[APP_CAN_VIEW_DASHBOARD]: {
		description: "Can access the application dashboard",
		type: "internal"
	},
	[APP_CAN_EDIT_ALL_AGENTS]: {
		description: "Can edit all agents in the system",
		type: "internal"
	},
	[APP_CAN_DELETE_ALL_AGENTS]: {
		description: "Can delete all agents in the system",
		type: "internal"
	},
	[APP_CAN_LIST_ALL_AGENTS]: {
		description: "Can list all agents in the system",
		type: "internal"
	},
	[APP_CAN_EDIT_ALL_WORKSPACES]: {
		description: "Can edit all workspaces in the system",
		type: "internal"
	},
	[APP_CAN_CREATE_WEBPAGE]: {
		description: "Can create webpages",
		type: "internal"
	},
	[APP_CAN_READ_WEBPAGE]: {
		description: "Can read webpages",
		type: "internal"
	},
	[APP_CAN_UPDATE_WEBPAGE]: {
		description: "Can update webpages",
		type: "internal"
	},
	[APP_CAN_DELETE_WEBPAGE]: {
		description: "Can delete webpages",
		type: "internal"
	},
	[APP_CAN_MANAGE_WEBPAGE]: {
		description: "Can manage webpages",
		type: "internal"
	},
	[APP_CAN_VIEW_MODEL_PROFILES]: {
		description: "Can view model profiles",
		type: "internal"
	},
	[APP_CAN_CREATE_MODEL_PROFILES]: {
		description: "Can create model profiles",
		type: "internal"
	},
	[APP_CAN_READ_MODEL_PROFILES]: {
		description: "Can read model profiles",
		type: "internal"
	},
	[APP_CAN_UPDATE_MODEL_PROFILES]: {
		description: "Can update model profiles",
		type: "internal"
	},
	[APP_CAN_DELETE_MODEL_PROFILES]: {
		description: "Can delete model profiles",
		type: "internal"
	},
	[APP_CAN_EXECUTE_LLM_PROFILE_TOOLS]: {
		description: "Can execute LLM profile tools",
		type: "internal"
	},
	[APP_CAN_LIST_TRANSACTIONS]: {
		description: "Can list and search transactions",
		type: "internal"
	},
	[APP_CAN_CREATE_TRANSACTION]: {
		description: "Can create a transaction record",
		type: "internal"
	},
	[APP_CAN_READ_TRANSACTION]: {
		description: "Can read transaction record",
		type: "internal"
	},
	[APP_CAN_UPDATE_TRANSACTION]: {
		description: "Can update transaction record",
		type: "internal"
	},
	[APP_CAN_DELETE_TRANSACTION]: {
		description: "Can delete transaction record",
		type: "internal"
	},
	[APP_IGNORE_LIMITS]: {
		description: "Can ignore platform limits",
		type: "internal"
	}
};

//#endregion
export { ALL_APP_PERMISSIONS, APP_CAN_ACCESS_BACKEND, APP_CAN_ACCESS_MINI_APP, APP_CAN_ASSIGN_CHATROOM_ROLES, APP_CAN_ASSIGN_ORGANIZATION_ROLES, APP_CAN_ASSIGN_PLANS, APP_CAN_ASSIGN_ROLES, APP_CAN_CREATE_MODEL_PROFILES, APP_CAN_CREATE_ORGANIZATION, APP_CAN_CREATE_PLAN, APP_CAN_CREATE_ROLE, APP_CAN_CREATE_TRANSACTION, APP_CAN_CREATE_USER, APP_CAN_CREATE_WEBPAGE, APP_CAN_DELETE_ALL_AGENTS, APP_CAN_DELETE_MODEL_PROFILES, APP_CAN_DELETE_ORGANIZATION, APP_CAN_DELETE_PLAN, APP_CAN_DELETE_ROLE, APP_CAN_DELETE_TRANSACTION, APP_CAN_DELETE_USER, APP_CAN_DELETE_WEBPAGE, APP_CAN_EDIT_ALL_AGENTS, APP_CAN_EDIT_ALL_WORKSPACES, APP_CAN_EXECUTE_LLM_PROFILE_TOOLS, APP_CAN_LIST_ALL_AGENTS, APP_CAN_LIST_ORGANIZATIONS, APP_CAN_LIST_PLANS, APP_CAN_LIST_ROLES, APP_CAN_LIST_TRANSACTIONS, APP_CAN_LIST_USERS, APP_CAN_MANAGE_PERMISSIONS, APP_CAN_MANAGE_PLAN_WEBSITE_VISIBILITY, APP_CAN_MANAGE_ROLES, APP_CAN_MANAGE_WEBPAGE, APP_CAN_READ_MODEL_PROFILES, APP_CAN_READ_ORGANIZATION, APP_CAN_READ_PLAN, APP_CAN_READ_ROLE, APP_CAN_READ_TRANSACTION, APP_CAN_READ_USER, APP_CAN_READ_WEBPAGE, APP_CAN_UPDATE_MODEL_PROFILES, APP_CAN_UPDATE_ORGANIZATION, APP_CAN_UPDATE_PLAN, APP_CAN_UPDATE_ROLE, APP_CAN_UPDATE_TRANSACTION, APP_CAN_UPDATE_USER, APP_CAN_UPDATE_WEBPAGE, APP_CAN_VIEW_DASHBOARD, APP_CAN_VIEW_LOGS, APP_CAN_VIEW_MODEL_PROFILES, APP_IGNORE_LIMITS, CAN_ACCESS_MYSTIC, CAN_BAN_USERS, CAN_CREATE_AGENTS, CAN_CREATE_CHAT_ROOMS, CAN_CREATE_WIKI_PAGES, CAN_CREATE_WORKSPACES, CAN_CREATE_WORKSPACE_DEPLOYMENTS, CAN_DELETE_AGENTS, CAN_DELETE_LLM_PROFILE, CAN_DELETE_MESSAGES, CAN_DELETE_ROOM, CAN_DELETE_WIKI_PAGES, CAN_DELETE_WORKSPACES, CAN_DELETE_WORKSPACE_DEPLOYMENTS, CAN_EDIT_CHAT_ROOM, CAN_EXECUTE_AGENT_TOOLS, CAN_INVITE_AI_AGENTS_TO_ROOM, CAN_INVITE_USERS_TO_ROOM, CAN_KICK_USERS, CAN_LIST_AGENTS, CAN_LIST_WIKI_PAGES, CAN_LIST_WORKSPACES, CAN_MANAGE_AIS_IN_ROOM, CAN_MANAGE_CHAT_ROOM_ROLES, CAN_MANAGE_INTEGRATIONS, CAN_MANAGE_ORGANIZATION_BILLING, CAN_MANAGE_ORGANIZATION_USERS, CAN_MANAGE_WIKI_PAGES, CAN_MANAGE_WORKSPACE_DEPLOYMENTS, CAN_PUBLISH_WORKSPACES, CAN_QUERY_LLM_PROFILE, CAN_READ_AGENTS, CAN_READ_LLM_PROFILE, CAN_READ_WIKI_PAGES, CAN_READ_WORKSPACES, CAN_READ_WORKSPACE_DEPLOYMENTS, CAN_UPDATE_AGENTS, CAN_UPDATE_LLM_PROFILE, CAN_UPDATE_WIKI_PAGES, CAN_UPDATE_WORKSPACES, CAN_UPDATE_WORKSPACE_DEPLOYMENTS, CAN_WRITE_LLM_PROFILE, IS_ORGANIZATION_ACCOUNT_OWNER, PERMISSION_DEFINITIONS };
//# sourceMappingURL=permissions.js.map